module.exports = __webpack_public_path__ + "img/wap_slides_bg_04.e0fbedf3.png";